export var REQUEST_HOMEMADE_CATEGORY = 'REQUEST_HOMEMADE_CATEGORY';
export var SUCCESS_HOMEMADE_CATEGORY = 'SUCCESS_HOMEMADE_CATEGORY';
export var FAILURE_HOMEMADE_CATEGORY = 'FAILURE_HOMEMADE_CATEGORY';
export var REQUEST_HOMEMADE_CATEGORY_DETAIL = 'REQUEST_HOMEMADE_CATEGORY_DETAIL';
export var SUCCESS_HOMEMADE_CATEGORY_DETAIL = 'SUCCESS_HOMEMADE_CATEGORY_DETAIL';
export var FAILURE_HOMEMADE_CATEGORY_DETAIL = 'FAILURE_HOMEMADE_CATEGORY_DETAIL';